module.exports = __webpack_public_path__ + "static/media/lotto-landing-copy-only-version.e238d2c6.png";